import { DesignParams, designParamsSchema } from '../../commerce/merch/utils/getDesignParams';
import { getSearchString } from '../../utils';

const Products = (params?: DesignParams) => `/products${getSearchString(params)}`;

export const CommerceRoutes = {
	Collections: '/collections',
	Brands: '/brands',
	Brand: (slug: string) => `/brands/${slug.toLowerCase()}`,
	Products,
	Product: (productSlug: string, params?: DesignParams) =>
		`/products/${productSlug.toLowerCase()}${getSearchString(params, designParamsSchema)}`,
	Collection: (collectionSlug: string, params?: DesignParams) =>
		`/collections/${collectionSlug.toLowerCase()}${getSearchString(params, designParamsSchema)}`,
	Category: (slug: string, params?: DesignParams) => `/collections/${slug}${getSearchString(params, designParamsSchema)}`,
	Cart: '/cart',
	CartTransfer: (cartId: string) => `/cart/transfer?cartId=${cartId}`,
	Checkout: {
		Information: '/checkout',
		Shipping: '/checkout/shipping',
		Payment: '/checkout/payment',
		Afterpay: {
			init: '/checkout/payment/afterpay/init',
			success: '/checkout/payment/afterpay/success',
			failure: '/checkout/payment/afterpay/failure',
		},
		Processing: (orderId?: string) => `/checkout/processing?orderId=${orderId}`,
		Success: (orderId?: string) => `/checkout/success?orderId=${orderId}`,
	},
	PaymentRequest: {
		Base: '/payment-request',
		Index: (id: string, view: string) => `/payment-request?id=${id}&view=${view}`,
		Processing: (id: string, view: string) => `/payment-request/processing?id=${id}&view=${view}`,
		Success: (id: string, view: string) => `/payment-request/success?id=${id}&view=${view}`,
	},
	OrderStatus: (orderId: string, viewId: string) => `/order-status?orderId=${orderId}&viewId=${viewId}`,
	FindMyOrder: (data: { order?: string; itemId?: string; email?: string; viewId?: string } | undefined) => {
		const params: Record<string, string> = {};
		if (data?.order) params.order = data.order;
		if (data?.email) params.email = data.email;
		if (data?.viewId) params.viewId = data.viewId;

		return `/find-my-order${data?.itemId ? `/${data.itemId}` : ''}${getSearchString(params)}`;
	},
	OrderInvoice: (orderId: string, viewId: string) => `/find-my-order/${orderId}.pdf?viewId=${viewId}`,
} as const;
